export default "__VITE_ASSET__DaP5t19___"